import { useEffect } from "react";
export function useTitle(title: string) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title ?? "HomeRun";
    return () => {
      document.title = prevTitle ?? "HomeRun";
    };
  });
}
